<template>
    <div class="years-container">
        <div class="year" v-for="annee in annees" :key="annee" @click="emitSelect(annee)" @keydown.enter.prevent="emitSelect(annee)" @keydown.space.prevent="emitSelect(annee)" tabindex="0" role="button">
            <span>
                {{annee}}
            </span>
        </div>
    </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import dayjs from 'dayjs';

export default defineComponent({
    name: 'AnneeChips',
    emits: ['select'],
    data() {
        const annees = [ dayjs().year().toString(),
            dayjs().subtract(1, 'year').year().toString(),
            dayjs().subtract(2, 'year').year().toString(),
            dayjs().subtract(3, 'year').year().toString()
        ];
        return { annees };
    },
    methods: {
        emitSelect(item: string) {
            this.$emit('select', item);
        },
    },
});
</script>

<style scoped>
.years-container {
    margin-top: 3px;
    display: flex;
    font-size: var(--font-size-very-small);
    gap: 3%;
}
.year {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 50px;
    height: 24px;
    border-radius: 12px;
    background-color: var(--medium-dark-grey);
    border: 1px solid var(--color-principal);
    color: white;
    cursor: pointer;
}
</style>
